/**
 * Pool of AI opponents. They reuse the existing skins (so they render with the same
 * rig/sprite) and carry a baseline pace per discipline. Per-race noise is applied when
 * a race starts, so results vary. Names are deliberately silly for the comedy tone.
 */
export interface AiOpponent {
  id: string;
  name: string;
  species: string;
  skin: string;
  nationality: string;
  /** Baseline 100m time in seconds (lower = faster). */
  sprintTime: number;
  /** Baseline long-jump distance in metres. */
  jumpDistance: number;
}

export const AI_POOL: AiOpponent[] = [
  { id: 'ai_cheetah', name: 'Furia Felina', species: 'cheetah', skin: 'cheetah', nationality: 'BRA', sprintTime: 10.5, jumpDistance: 6.4 },
  { id: 'ai_meerkat', name: 'Suri Sprint', species: 'meerkat', skin: 'meerkat', nationality: 'JPN', sprintTime: 11.6, jumpDistance: 6.1 },
  { id: 'ai_gorilla', name: 'Re Banana', species: 'gorilla', skin: 'gorilla', nationality: 'COD', sprintTime: 12.8, jumpDistance: 5.6 },
  { id: 'ai_sloth', name: 'Lento Pede', species: 'sloth', skin: 'sloth', nationality: 'CRC', sprintTime: 15.2, jumpDistance: 4.2 },
  { id: 'ai_ostrich', name: 'Piuma Lampo', species: 'ostrich', skin: 'ostrich', nationality: 'GER', sprintTime: 10.8, jumpDistance: 5.8 },
  { id: 'ai_kangaroo', name: 'Balzo Boxer', species: 'kangaroo', skin: 'kangaroo', nationality: 'AUS', sprintTime: 12.0, jumpDistance: 6.8 },
  { id: 'ai_hare', name: 'Lampo Lepre', species: 'hare', skin: 'hare', nationality: 'GBR', sprintTime: 11.2, jumpDistance: 6.0 },
  { id: 'ai_elephant', name: 'Bestione', species: 'elephant', skin: 'elephant', nationality: 'IND', sprintTime: 14.5, jumpDistance: 4.5 },
];

/** Pick `count` opponents whose skin differs from the player when possible. */
export function pickOpponents(playerSkin: string, count: number): AiOpponent[] {
  const pool = [...AI_POOL];
  // Prefer a varied field: put different-skin opponents first.
  pool.sort((a, b) => Number(a.skin === playerSkin) - Number(b.skin === playerSkin));
  return pool.slice(0, count);
}
